import { computed, observable, override, makeObservable } from 'mobx';
import InterviewGuideQuestion from './InterviewGuideQuestion';
import {QAAnswer} from 'main/stores/questions';

class InterviewGuideAnswer extends QAAnswer {
  id;
  content;
  _relations = {
    question: InterviewGuideQuestion
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      content: observable,
      updateValue: override,
      value: computed
    });

    this.merge(other);
  }

  updateValue(value) {
    this.content = value;
  }

  get value() {
    return this.content;
  }
}

export default InterviewGuideAnswer;
